/**
 * Bridges StatefulMacroCoordinator's macro-active state onto a replicated
 * `{ macroRunning }` store. The store is replicated to players, so this is the
 * host→player signal for the debug "macro running" indicator. No new native /
 * Playjector message is involved — the host already knows the macro-active
 * state from the coordinator.
 */

import type { StateStore } from '@playcastdotio/CoreTypes';
import type { StatefulMacroCoordinator } from './StatefulMacroCoordinator';

export type MacroRunningStore = StateStore<{ macroRunning: boolean }>;

export function wireMacroRunningReplication(
  coordinator: StatefulMacroCoordinator,
  store: MacroRunningStore,
): () => void {
  return coordinator.subscribeActive((active) => {
    if (store.currentState.macroRunning !== active) {
      store.updateState({ macroRunning: active });
    }
  });
}
